import isString from 'onyx-common/isString'

const textCompare = text => {
  if (!isString(text)) return text

  return text.trim().toLowerCase()
}

export default textCompare
